import { createContext } from 'react'

export const DmAgentEnabledContext = createContext<boolean>(false)
